<template>
    <!-- 考勤信息 -->
    <div>
        <div class="conditionSearchBox">
            <div class="conditionItem">
                <el-input v-model="params.condition.classname" placeholder="班级名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.classcoursename" placeholder="课程名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.periodname" placeholder="课时名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
                <el-button type="" icon="el-icon-refresh" @click="reset">重置</el-button>
            </div>
        </div>
        <el-table :data="tableData" border class="table-fixed-col" v-loading="contentLoading" ref="table">
            <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                <template slot-scope="scope">
                    <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                </template>
            </el-table-column>
            <el-table-column prop="classname" label="班级名称" align="center" min-width="200" key="classname" fixed show-overflow-tooltip>
                <template slot-scope="scope">
                    <p class="color-brand pointer text-ellipse" @click="openAttendanceInfoDialog(scope.row)">{{scope.row.classname}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="classcoursename" label="课程名称" align="center" min-width="150" key="classcoursename" fixed show-overflow-tooltip></el-table-column>
            <el-table-column prop="periodname" label="课时名称" align="center" width="200" key="periodname" :formatter="formatTab" show-overflow-tooltip></el-table-column>
            <el-table-column prop="shouldcount" label="应考勤数" align="center" width="100" key="shouldcount" :formatter="formatTab" show-overflow-tooltip></el-table-column>
            <el-table-column prop="normalcount" label="正常考勤数" align="center" width="100" key="normalcount"></el-table-column>
            <el-table-column prop="leavecount" label="请假数" align="center" width="100" key="leavecount" :formatter="formatTab"></el-table-column>
            <el-table-column prop="uncount" label="未考勤数" align="center" width="100" key="uncount" :formatter="formatTab"></el-table-column>
        </el-table>
        <Page v-if="total > 0" @pageChange="pageChange" @pagesizeChange="pagesizeChange" :total="total" :page="params.page" :pagesize="params.pagesize" />
        <AttendanceInfoDialog ref="AttendanceInfoDialog" :classCode="classCode" :courseCode="courseCode" :code="code"></AttendanceInfoDialog>
    </div>
</template>
<script>
import { getTableDefaultPageSize } from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import Page from '@/components/measComponents/page/page.vue'
import { getStudyListByPeriod } from '@/api/measApi/studyManagement.js'
import AttendanceInfoDialog from './components/attendanceInfoDialog.vue'
export default {
  data() {
    return {
      params: {
        condition: {
          classcode: '', // 班级code
          classcoursecode: '', // 班级课程code
          classcoursename: '', // 班级课程名称
          classname: '', // 班级名
          periodcode: '', // 课时Code
          periodname: '' // 课时名称
        },
        page: 1,
        pagesize: getTableDefaultPageSize()
      },
      contentLoading: false,
      tableData: [],
      total: 0,
      isSelect: false,
      date: [],
      classCode: '',
      courseCode: '',
      code: ''
    }
  },
  components: {
    TableSort,
    Page,
    AttendanceInfoDialog
  },
  created() {
    this.getStudyListByPeriod()
  },
  methods: {
    //   获取作业列表
    getStudyListByPeriod() {
      this.contentLoading = true
      getStudyListByPeriod(this.params).then(res => {
        if (res.code === '000') {
          this.tableData = res.data
          this.contentLoading = false
          this.total = res.pageinfo.rowcount
        }
      })
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getStudyListByPeriod()
    },
    // 重置
    reset() {
      this.params = {
        condition: {
          classcode: '', // 班级code
          classcoursecode: '', // 班级课程code
          classcoursename: '', // 班级课程名称
          classname: '', // 班级名
          periodcode: '', // 课时Code
          periodname: '' // 课时名称
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      }
      this.getStudyListByPeriod()
    },
    // 分页
    pageChange(page) {
      this.params.page = page
      this.getStudyListByPeriod()
    },
    pagesizeChange(size) {
      this.params.page = 1
      this.params.pagesize = size
      this.getStudyListByPeriod()
    },
    // 初始化表格
    formatTab(row, column, value) {
      return value ? value : '--'
    },
    openAttendanceInfoDialog(row) {
      this.code = row.code
      this.$refs.AttendanceInfoDialog.handleOpen(row)
    }
  }
}
</script>
